import "core-js/modules/es.function.name.js";
export default {
  name: "MenuItem",
  props: ["menuItemData"],
  computed: {
    isForceMenuOn: function isForceMenuOn() {
      return this.menuItemData.route_name == "adminRegionList" && this.$route.name == "adminRegionDetails" || this.menuItemData.route_name == "userRegionList" && (this.$route.name == "userRegionDetails" || this.$route.name == "userProducerDetails") || this.menuItemData.route_name == "adminProducerList" && this.$route.name == "adminProducerDetails" || this.menuItemData.route_name == "adminProductList" && (this.$route.name == "adminWineDetails" || this.$route.name == "adminSpiritsDetails") || this.menuItemData.route_name == "adminStockList" && this.$route.name == "adminStockDetails" || this.menuItemData.route_name == "adminUserList" && (this.$route.name == "adminUserDetails" || this.$route.name == "adminUserRoles") || this.menuItemData.route_name == "adminOrderList" && this.$route.name == "adminOrderSummary" || this.menuItemData.route_name == "adminEventList" && this.$route.name == "adminEventDetails";
    }
  },
  methods: {
    getRoute: function getRoute(routeName) {
      var query = null;
      if (routeName === "userOrderList") query = {
        tab: "orders"
      };else if (routeName === "adminOrderList") query = {
        tab: "orders"
      };else if (routeName === "adminProductList") query = {
        tab: "wines"
      };else if (routeName === "userProductList") query = {
        tab: "wines"
      };
      return {
        name: routeName,
        query: query
      };
    }
  }
};